import { ActionReference, DefaultGameState, GameObjectReference, GameState } from "@shared/types";
import { css, html, htmlArray } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { GameRouteService } from "../services/GameRouteService";
import { Page } from "../enums/Page";
import { LeaderboardService } from "../services/LeaderboardService";

/** CSS affecting the {@link CanvasComponent} */
const styles: string = css`
    :host {
        font-family: "Onesize";
        width: 100%;
        max-width: 80vw;
        height: 100%;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto calc(35vh + 10px) minmax(calc(35vh + 10px), 1fr) auto;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
    }

    .title {
        text-align: center;
        margin-top: 10px;
        overflow: auto;
    }

    .header-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
    }

    .header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-items: center;
        position: relative;
        margin-top: 10px;
        height: 250px;
        width: 85%; /* Zorgt ervoor dat de header niet te breed is */
    }

    .header img {
        border-radius: 1rem;
    }

    .header img:nth-child(1){
        width: 100%;
        height: 150%;
        image-rendering: pixelated;
        pointer-events: none;
    }

    .header-sidebar {
        display: flex;
        margin-top: 12vh;
        flex-direction: column;
        gap: 10px;
        width: 10%; /* Reserveren van ruimte voor journal en map */
        align-items: center;
        justify-content: center; /* Verticale centrering */
        height: 100%; /* Zorgt ervoor dat de sidebar zich uitstrekt tot de volledige hoogte van de parent */
    }

    .header-sidebar img {
        border: 2px solid #9b96b4;
        background: url('/assets/img/rooms/castle.png');
        border-radius: 1rem;
        width: 80%; /* Zorgt ervoor dat ze kleiner zijn maar meeschalen */
        height: auto;
    }

    .header [data-alias= "ring"] {
        width: 25px;
        height: 25px;
        top: calc(108% + 20px);
        padding-right: 50px;
    }

    .header [data-alias= "graaf"] {
        width: 300px;
        height: 200px;
        top: calc(62% + 20px);
    }


    .header [data-alias= "henk1"], [data-alias= "ethan1"], [data-alias= "timi1"], [data-alias= "dagboek1"], [data-alias= "briefcontract"], [data-alias= "HerbergBrief"] {
        width: 100%;
        height: 150%;
        image-rendering: pixelated;
        pointer-events: none;
    }

    .header [data-alias= "GiftigMist"]{
        width: 95%;
        height: 130%;
        image-rendering: pixelated;
        opacity: 70%;
    }

    .header [data-alias= "Skull"]{
        width: 115px;
        height: 115px;
        top: calc(90% + 25px);
        margin-right: 40%;
    }

    .header [data-alias= "slot"]{
        width: 60px;
        height: 30px;
        top: calc(60% + 20px);
        margin-right: 5px;
    }

    .header [data-alias= "Bryan2"] {
        width: 350px;
        height: 350px;
        top: calc(25px);
        margin-right: 30%;
    }

    .header [data-alias= "bloedvlekken"] {
        width: 200px;
        height: 200x;
        top: calc(100% + 25px);
    }

    .header [data-alias= "sleutel"] {
        width: 180px;
        height: 180x;
        top: calc(95% + 25px);
        margin-right: 30%;
    }

    .header [data-alias= "skelet"] {
        width: 200px;
        height: 200px;
        top: calc(50% + 25px);
        margin-left: 40%;
    }

    .header [data-alias= "BryanZonderBoek"] {
        width: 350px;
        height: 350px;
        top: calc(25px);
        margin-right: 30%;
    }

    .header [data-alias= "dagboek"] {
        width: 80px;
        height: 80px;
        top: calc(100% + 20px);
        margin-left: 50%;
    }

    .header [data-alias= "henk"] {
        width: 200px;
        height: 200px;
        top: calc(50% + 20px);
        margin-left: 400px;
    }

    .header [data-alias= "ethan"] {
        width: 150px;
        height: 150px;
        top: calc(60% + 20px);
        margin-right: 380px;
    }

    .header [data-alias= "timi"] {
        width: 90px;
        height: 90px;
        top: calc(58% + 20px);
        margin-right: 790px;
    }

    .header [data-alias= "easterJoey"] {
        width: 30px;
        height: 30px;
        top: calc(10px);
        margin-right: 550px;
    }

    .header [data-alias= "gesloten-kist"] {
        width: 60px;
        height: 60px;
        top: calc(90% + 20px);
        margin-right: 160px;
    }

    .header [data-alias= "geopende-kist"] {
        width: 60px;
        height: 60px;
        top: calc(90% + 20px);
        margin-right: 160px;
    }

    .header [data-alias= "woudKist-vergroot-dicht"] {
        width: 330px;
        height: 330px;
        pointer-events: none;
    }

    .header [data-alias= "Talisman"] {
        width: 80px;
        height: 80px;
        top: calc(60% + 20px);
        margin-right: 60px;
    }

    .header [data-alias= "woudKist-vergroot-open"] {
        width: 600px;
        height: 400px;
        pointer-events: none;
    }

    .header [data-alias= "Augustijn"] {
        width: 150px;
        height: 160px;
        top: calc(80% + 20px);
        margin-right: 400px;
    }

    .header [data-alias= "Combined-Briefje-groot"] {
        width: 180%;
        height: 180%;
    }

    .header [data-alias= "Gescheurde-briefjes-groot"] {
        width: 100%;
        height: 150%;
        pointer-events: none;
    }

    .header [data-alias= "Abt"] {
        width: 300px;
        height: 300px;
        top: calc(22% + 20px);
        margin-right: 30%;
    }

    .header [data-alias= "broeder_Dale"] {
        width: 450px;
        height: 350px;
        top: calc(25px);
        margin-right: 30%;
    }

    .header [data-alias= "boek_met_symbolen"], [data-alias = "book"]{
        width: 80px;
        height: 80px;
        top: calc(100% + 20px);
        margin-left: 43%;
    }

    .header [data-alias= "Gescheurde-briefjes"], [data-alias= "GescheurdBriefjeLinkerhelft"], [data-alias= "CombinedBriefje"], [data-alias= "briefjeWoudKist49"], [data-alias= "briefcontract1"], [data-alias= "HerbergBrief1"], [data-alias= "gesloten_Herbergbrief"]{
        width: 25px;
        height: 25px;
        top: calc(90% + 20px);
        margin-left: 400px;
    }

    .header [data-alias= "ridder"] {
        width: 300px;
        height: 250px;
        top: calc(40% + 20px);
        margin-left: 70%;
    }

    .header [data-alias= "johanHerbergier"] {
        width: 380px;
        height: 350px;
        top: calc(25px);
        margin-right: 30%;
    }

    .header [data-alias= "monikken"] {
        width: 120px;
        height: 150px;
        top: calc(82% + 20px);
        margin-left: 78%;
    }

    .header [data-alias= "tovenaar"] {
        width: 200px;
        height: 200px;
        top: calc(60% + 20px);
        margin-right: 40%;
    }

    .header [data-alias= "puzzel"] {
        width: 50px;
        height: 50px;
        top: calc(60% + 20px);
        margin-right: 35%;
    }

    .header img:nth-child(n + 2) {
        position: absolute;
    }

    .content {
        width: 85%;
        flex-grow: 1;
        overflow: auto;
        margin-top: 130px;
        padding: 0 10px;
    }

    .content p {
        margin: 0 0 10px 0;
    }

    .content p:last-of-type {
        margin: 0;
    }

    .footer {
    align-items: center;
    box-shadow: 100px white;
    width: 85%;
    height: 140px;
    border-radius: 1rem;
    margin-bottom: 2vh;
    display: flex;
    background: url('/assets/img/rooms/castle.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
}

.footer::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.35);  /* Dark overlay */
    pointer-events: none;
}


    .footer .buttons {
        position: absolute;
        align-items: center;    
        display: flex;
        flex-direction: row;
        overflow: auto;
        padding: 10px 10px 0 10px;
        max-width: 95%; /* Maximaal 80% van de breedte van de footer */
        margin-left: 2%; /* Zorgt ervoor dat de knoppen aan de linkerzijde beginnen */
    }

    .footer .button {
        height: 50px;
        background: url('/assets/img/rooms/castle.png');
        border: 2px solid #9b96b4;
        padding: 10px;
        margin: 0 0 10px 10px;
        text-transform: uppercase;
        cursor: pointer;
        display: inline-block;
        user-select: none;
        color: #fff;
        transition: background-color 0.3s ease, transform 0.2s ease;
        font-size: 1rem;
        border-radius: 1rem;
    }


.footer .button.active,
.footer .button:hover {
    background-color: #332c57;
    transform: translateY(-3px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.footer img {
    max-height: 100%;
    object-fit: contain;
}

.clickable {
        cursor: pointer;
        transition: transform 0.2s ease-in-out;
    }

    .clickable:hover {
        transform: scale(1.03); /* Slightly enlarge */
    }

`;
let stack: HTMLImageElement[] = [];
const canvas: HTMLCanvasElement = document.createElement("canvas");
const ctx: CanvasRenderingContext2D | null = canvas.getContext("2d");
/**
 * Represents the Canvas page
 */
export class CanvasComponent extends HTMLElement {
    /** Instance of the game event service */
    private readonly _gameEventService: GameEventService = new GameEventService();
    /** Instance of the game route service */
    private readonly _gameRouteService: GameRouteService = new GameRouteService();
    private leaderboardService: LeaderboardService = new LeaderboardService();

    /** Current game state */
    private _currentGameState?: DefaultGameState;
    /** Current active action button */
    private _selectedActionButton?: ActionReference;
    /** Current active game object buttons */
    private _selectedGameObjectButtons: Set<GameObjectReference> = new Set<GameObjectReference>();

    /**
     * De "constructor" van de Web Component
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        void this.refreshGameState();
    }

    /**
     * Refresh de huidige game state
     */
    private async refreshGameState(): Promise<void> {
        const state: GameState = await this._gameRouteService.getGameState();
        this.updateGameState(state);
    }

    /**
     * Update het canvas naar de meegegeven game state
     *
     * @param state Game state waarop het canvas geüpdatet moet worden
     */
    private updateGameState(state: GameState): void {
        // Indien van het type switch-page, schakel dan over naar de betreffende pagina
        if (state.type === "switch-page") {
            this._gameEventService.switchPage(state.page as Page);
            return;
        }

        // Reset de huidige state en geselecteerde knoppen
        this._currentGameState = state;
        this._selectedActionButton = undefined;
        this._selectedGameObjectButtons.clear();

        // Roep de asynchrone render functie aan
        void this.render();
    }

    /**
     * Render de inhoud van deze component.
     * Zorgt ervoor dat asynchrone onderdelen (zoals renderHeader) eerst zijn afgerond.
     */
    private async render(): Promise<void> {
        if (!this.shadowRoot) {
            return;
        }

        // Wacht op asynchrone onderdelen
        const headerHtml: string = await this.renderHeader();
        const titleHtml: string = this.renderTitle();
        const contentHtml: string = this.renderContent();
        const footerHtml: HTMLElement = this.renderFooter();

        // Maak de volledige HTML op basis van een helper, bijvoorbeeld htmlArray (hier verondersteld als een tagged template)
        const elements: HTMLElement[] = htmlArray`
            <style>
                ${styles}
            </style>
            ${titleHtml}
            ${headerHtml}
            ${contentHtml}
            ${footerHtml}
        `;

        // Maak de shadowRoot leeg en voeg de nieuwe elementen toe
        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }
        this.shadowRoot.append(...elements);

        // Voeg event listeners toe nadat de elementen in de DOM staan

        const journalButton: HTMLElement | null = this.shadowRoot.querySelector("#journal");
        if (journalButton) {
            journalButton.addEventListener("click", (event: Event) => {
                event.preventDefault();
                this._gameEventService.switchPage(Page.Journal);
            });
        }
        else {
            console.error("Journal button not found!");
        }

        const travelMapButton: HTMLElement | null = this.shadowRoot.querySelector("#travel-map");
        if (travelMapButton) {
            travelMapButton.addEventListener("click", () => {
                console.log("Travel Map");
                this._gameEventService.switchPage(Page.TravelMap);
            });
        }
        else {
            console.error("Travel map button not found!");
        }

        const inventoryButton: HTMLElement = this.shadowRoot.querySelector("#inventory") as HTMLElement;
        inventoryButton.addEventListener("click", () => {
            console.log("Inventory");
            this._gameEventService.switchPage(Page.Inventory);
        });

        // Voeg pointer event listeners toe aan alle img-elementen in de component
        this.shadowRoot.querySelectorAll("img").forEach(element => {
            element.addEventListener("pointerdown", ev =>
                this.transPNG(ev, ev.currentTarget as HTMLImageElement)
            );
            element.addEventListener("mousemove", ev =>
                this.transPNGClickable(ev as PointerEvent, ev.currentTarget as HTMLImageElement)
            );
        });
    }

    /**
     * Event handler voor pointermove, die controleert of het doel element klikbaar is.
     */
    private transPNGClickable(ev: PointerEvent, target: HTMLImageElement | null): void {
        if (!target) return;
        if (!(target instanceof HTMLImageElement)) {
            console.error("Target is not an HTMLImageElement:", target);
            return;
        }

        if (!ctx) {
            console.error("Canvas context could not be initialized.");
            return;
        }
        // Bepaal de coördinaten binnen het element
        const rect: DOMRect = target.getBoundingClientRect();
        const x: number = ev.clientX - rect.left;
        const y: number = ev.clientY - rect.top;
        const w: number = target.width;
        const h: number = target.height;
        let alpha: number = 255; // Standaard: ondoorzichtig

        // Teken het element op een canvas en lees de Alpha waarde uit
        canvas.width = w;
        canvas.height = h;
        ctx.drawImage(target, 0, 0, w, h);
        const pixelData: Uint8ClampedArray = ctx.getImageData(x, y, 1, 1).data;
        alpha = pixelData[3]; // [0]R [1]G [2]B [3]A

        if (alpha === 0) { // Als de pixel transparant is...
            target.classList.remove("clickable");
        }
        else {
            target.classList.add("clickable");
        }
    }

    /**
     * Event handler voor pointerdown, die bepaalt of op het element is geklikt.
     */
    private async transPNG(ev: PointerEvent, target: HTMLImageElement | null): Promise<void> {
        if (!target) return;
        if (!(target instanceof HTMLImageElement)) {
            console.error("Target is not an HTMLImageElement:", target);
            return;
        }

        if (!ctx) {
            console.error("Canvas context could not be initialized.");
            return;
        }
        // Bepaal de coördinaten binnen het element
        const rect: DOMRect = target.getBoundingClientRect();
        const x: number = ev.clientX - rect.left;
        const y: number = ev.clientY - rect.top;
        const w: number = target.width;
        const h: number = target.height;
        let alpha: number = 255;

        canvas.width = w;
        canvas.height = h;
        ctx.drawImage(target, 0, 0, w, h);
        const pixelData: Uint8ClampedArray = ctx.getImageData(x, y, 1, 1).data;
        alpha = pixelData[3];

        if (alpha === 0) { // Als pixel transparant is, schakel pointer events tijdelijk uit
            target.style.pointerEvents = "none";
            stack.push(target);
            setTimeout(() => {
                target.style.pointerEvents = "auto";
            }, 1);
        }
        else {
            // Herstel pointer events voor eerder uitgeschakelde elementen
            stack.forEach(el => (el.style.pointerEvents = "auto"));
            stack = [];

            console.clear();
            console.log(target.getAttribute("data-alias"));
            const alias: string | null = target.getAttribute("data-alias");

            // Werk de tekst in de huidige game state bij
            while (this._currentGameState?.text.length) {
                this._currentGameState.text.pop();
            }
            this._currentGameState?.text.push(`Je hebt op de ${alias} geklikt`);

            const gameObject: GameObjectReference | undefined = this._currentGameState?.objects.find(obj => obj.alias === alias);
            if (gameObject) {
                await this.handleClickGameObject(gameObject);
            }
        }
    }

    /**
     * Render de titel
     *
     * @returns HTML-string voor de titel. Kan leeg zijn.
     */
    private renderTitle(): string {
        const roomName: string | undefined = this._currentGameState?.roomName;
        if (roomName) {
            return `<div class="title">${roomName}</div>`;
        }
        return "";
    }

    /**
     * Render de header
     *
     * @returns HTML-string voor de header. Kan leeg zijn.
     */
    private async renderHeader(): Promise<string> {
        const roomImages: string[] | undefined = this._currentGameState?.roomImages;
        // Haal de game start status op
        const gameStartStatus: boolean = await this.leaderboardService.fetchGameStarted();

        // Toon de auth- en leaderboard buttons alleen als de game niet gestart is
        let buttonsHtml: string = "";
        if (!gameStartStatus) {
            buttonsHtml = `
                <div>
                    <leaderboard-button></leaderboard-button>
                </div>
            `;
        }

        if (!roomImages) {
            return `
                <div class="header-container">
                    <div class="header"></div>
                    <div class="header-sidebar">
                        <div class="journal">
                            <img src="../assets/img/rooms/journal.png" height="150px" width="150px" id="journal">
                        </div>
                        <div class="travel-map">
                            <img src="../assets/img/travelmap.png" height="150px" width="150px" id="travel-map">
                        </div>
                        <div>
                            <img src="../assets/img/rooms/Inventorybutton.png" height="100px" width="100px" id="inventory">
                        </div>
                        <div>
                          <auth-button></auth-button>
                        </div>
                        ${buttonsHtml}
                    </div>
                </div>`;
        }

        const imagesHtml: string = roomImages
            .map(img => {
                const gameObject: GameObjectReference = {
                    alias: img,
                    name: img.charAt(0).toUpperCase() + img.slice(1),
                };

                return `
                    <img
                        src="/assets/img/rooms/${img}.png"
                        class="game-object ${this._selectedGameObjectButtons.has(gameObject) ? "active" : ""}"
                        data-alias="${gameObject.alias}"
                    />
                `;
            })
            .join("");

        return `
            <div class="header-container">
                <div class="header">${imagesHtml}</div>
                <div class="header-sidebar">
                    <div class="journal">
                        <img src="../assets/img/rooms/journal.png" height="150px" width="150px" id="journal">
                    </div>
                    <div class="travel-map">
                        <img src="../assets/img/travelmap.png" height="150px" width="150px" id="travel-map">
                    </div>
                    <div>
                        <img src="../assets/img/rooms/Inventorybutton.png" height="100px" width="100px" id="inventory">
                    </div>
                    <div>
                    <auth-button></auth-button>
                    </div>
                    ${buttonsHtml}
                </div>
            </div>`;
    }

    /**
     * Render the content element
     *
     * @returns String with raw HTML for the content element
     */
    private renderContent(): string {
        return `
            <div class="content">
                ${this._currentGameState?.text.map(text => `<p>${text}</p>`).join("") || ""}
            </div>
        `;
    }

    /**
     * Render the footer element
     *
     * @returns HTML element of the footer
     */
    private renderFooter(): HTMLElement {
        console.log(this._currentGameState?.actions);
        const actions: ActionReference[] | undefined = this._currentGameState?.actions.filter(action => {
            return !action.needsObject || this._selectedGameObjectButtons.size > 0;
        });

        if (!actions?.length) {
            return html`<div class="footer"></div>`;
        }

        // // Check of het spel is gestart
        // const gameStarted: boolean = localStorage.getItem("gameStarted") === "true";

        return html`
            <div class="footer">

                <div class="buttons">
                    ${actions.map(button => this.renderActionButton(button))}
                </div>
            </div>
        `;
    }

    /**
     * Render an action button for a given action reference
     *
     * @returns HTML element of the action button
     */
    private renderActionButton(button: ActionReference): HTMLElement {
        const element: HTMLElement = html`
            <a class="button ${this._selectedActionButton === button ? "active" : ""}">
                ${button.name}
            </a>
        `;

        element.addEventListener("click", () => this.handleClickAction(button));

        return element;
    }

    /**
 * Handle the click on a game object button
 *
 * @param button Game object button that was clicked
 */
    private async handleClickGameObject(button: GameObjectReference): Promise<void> {
        this._selectedGameObjectButtons.clear();
        this._selectedGameObjectButtons.add(button);
        await this.render();
    }

    private async handleClickAction(button: ActionReference): Promise<void> {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (button.needsObject && (!this._selectedGameObjectButtons || this._selectedGameObjectButtons.size === 0)) {
            return;
        }

        const selectedObjects: string[] = [...this._selectedGameObjectButtons].map(e => e.alias);

        const state: GameState | undefined = await this._gameRouteService.executeAction(
            button.alias,
            selectedObjects.length > 0 ? selectedObjects : undefined
        );

        if (state !== undefined) {
            this._selectedGameObjectButtons.clear();
            this.updateGameState(state);
        }

        // Refresh the the web component
        await this.render();
    }
}
